(function(){
  var root=document.documentElement;
  function sizeInfo(){
    var radios=document.querySelectorAll('variant-selects input[type=radio]');
    var vals=[],checked=null;
    for(var i=0;i<radios.length;i++){
      var r=radios[i];
      if(/^(talla|size)/i.test(r.name||'')){vals.push(String(r.value).trim());if(r.checked)checked=String(r.value).trim();}
    }
    var uniq=vals.filter(function(v,i){return vals.indexOf(v)===i;});
    return uniq.length>1?{vals:uniq,initial:checked}:null;
  }
  function init(){
    var btn=document.querySelector('product-form button[type=submit]');
    if(!btn||document.getElementById('vl-sticky-js'))return;
    var old=document.querySelectorAll('#vl-sticky');
    for(var i=0;i<old.length;i++){old[i].parentNode.removeChild(old[i]);}
    var size=sizeInfo();
    var touched=!size||/[?&]variant=/.test(location.search);
    if(!touched)root.classList.add('vl-need-size');
    var msg=null;
    function sizeEl(){return document.querySelector('.product .swatch-view-button')||document.querySelector('variant-selects fieldset')||document.querySelector('variant-selects')||btn;}
    function showMsg(){
      if(!msg){
        msg=document.createElement('p');msg.className='vl-size-msg';msg.setAttribute('role','alert');
        msg.textContent='Elige tu talla para continuar';
        var host=btn.closest('.product-form__buttons')||btn.parentNode;
        host.parentNode.insertBefore(msg,host);
      }
      msg.classList.add('is-on');
      sizeEl().scrollIntoView({behavior:'smooth',block:'center'});
    }
    function markTouched(){
      if(touched)return;
      touched=true;root.classList.remove('vl-need-size');
      if(msg)msg.classList.remove('is-on');
      label();
    }
    if(size){
      document.addEventListener('change',function(e){
        var t=e.target;
        if(t&&t.type==='radio'&&/^(talla|size)/i.test(t.name||''))markTouched();
      },true);
      document.addEventListener('click',function(e){
        if(touched)return;
        var el=e.target;
        for(var k=0;el&&k<4;k++,el=el.parentNode){
          var tx=(el.textContent||'').trim();
          if(size.vals.indexOf(tx)>-1&&(el.closest&&el.closest('variant-selects,.swatch-view-button,[class*=swatch]'))){markTouched();return;}
        }
      },true);
      document.addEventListener('click',function(e){
        if(touched)return;
        var t=e.target;
        if(t&&t.closest&&t.closest('product-form button[type=submit]')){
          e.preventDefault();e.stopImmediatePropagation();showMsg();
        }
      },true);
    }
    var h1=document.querySelector('.product__title h1,.product__title');
    var title=h1?h1.textContent.trim():document.title;
    if(title.length>30)title=title.slice(0,29)+'…';
    var bar=document.createElement('div');
    bar.id='vl-sticky-js';bar.className='vl-sticky';
    var span=document.createElement('span');span.className='vl-sticky__t';span.textContent=title;
    var b=document.createElement('button');b.type='button';
    bar.appendChild(span);bar.appendChild(b);
    document.body.appendChild(bar);
    var below=true;
    function pick(){return !touched;}
    function label(){b.textContent=pick()?'Elegir talla':'Añadir al carrito';}
    label();
    var io=new IntersectionObserver(function(en){
      var e=en[0];
      if(e.isIntersecting){bar.classList.remove('is-on');return;}
      below=e.boundingClientRect.top>0;
      label();
      bar.classList.add('is-on');
    });
    io.observe(btn);
    b.addEventListener('click',function(){
      if(pick()){sizeEl().scrollIntoView({behavior:'smooth',block:'center'});}
      else{btn.click();}
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
